var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverstateiconCheckmyskin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 7.61116 7.61116 0 17 0V0C26.3888 0 34 7.61116 34 17V17C34 26.3888 26.3888 34 17 34V34C7.61116 34 0 26.3888 0 17V17Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 10.625C18.6532 12.0888 20.8127 12.851 23.0195 12.75C23.3408 13.843 23.4391 14.9894 23.3086 16.1211C23.1781 17.2528 22.8214 18.3467 22.2598 19.3379C21.6981 20.329 20.943 21.1971 20.0392 21.8907C19.1354 22.5842 18.1014 23.089 16.9987 23.375C15.896 23.089 14.862 22.5842 13.9582 21.8907C13.0544 21.1971 12.2993 20.329 11.7376 19.3379C11.176 18.3467 10.8193 17.2528 10.6888 16.1211C10.5583 14.9894 10.6566 13.843 10.9779 12.75C13.1847 12.851 15.3442 12.0888 16.9987 10.625Z",
    stroke: "#004276",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 16.9997L16.2917 18.4163L19.125 15.583",
    stroke: "#004276",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverstateiconCheckmyskin);
export default __webpack_public_path__ + "static/media/hover state icon -check my skin.92ab68da4159a3c1ca75bb0580ec64ee.svg";
export { ForwardRef as ReactComponent };